import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// GET /performance/me?bucket=week|month|year&fromDate=YYYY-MM-DD&toDate=YYYY-MM-DD
export const getMyPerformance = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/performance/me`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// GET /performance/team?bucket=week|month|year&fromDate=YYYY-MM-DD&toDate=YYYY-MM-DD&roleScope=all|sales|recruiter&userIds=...
// Note: Backend requires X-Business-Unit-Id header (applied globally by BusinessUnitContext).
export const getTeamPerformance = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/performance/team`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// GET /performance/financial-kpis?salesId=...
export const getFinancialKpis = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/performance/financial-kpis`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// GET /performance/portfolio-analysis?salesId=...
export const getPortfolioAnalysis = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/performance/portfolio-analysis`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

